import type {
  IanaTimezoneString,
  ApiISODateString,
  ApiISODateTimeNoTzString,
  ApiISOTimeString,
} from '#/api/types/ApiTypedDate';

export function splitIsoDateTimeStringNoTz(
  dateTimeString: ApiISODateTimeNoTzString,
): [ApiISODateString, ApiISOTimeString] {
  return dateTimeString.split('T') as [ApiISODateString, ApiISOTimeString];
}

function utcDateObjectFromIsoDateAndTime({
  date,
  time,
  timezone,
}: {
  date: ApiISODateString;
  time: ApiISOTimeString;
  timezone: IanaTimezoneString;
}) {
  const zuluDate = new Date(date + 'T' + time);
  const timezoneDate = new Date(
    zuluDate.toLocaleString('en', { timeZone: timezone }),
  );
  const offsetInMs = zuluDate.getTime() - timezoneDate.getTime();

  return new Date(zuluDate.getTime() + offsetInMs);
}

export function applyTimezoneOffsetToIsoDateAndTime({
  date,
  time,
  fromTimezone,
  toTimezone,
}: {
  date: ApiISODateString;
  time: ApiISOTimeString;
  fromTimezone: IanaTimezoneString;
  toTimezone: IanaTimezoneString;
}) {
  const utcDatetime = utcDateObjectFromIsoDateAndTime({
    date,
    time,
    timezone: fromTimezone,
  });

  // Format as the new timezone
  const newTimezoneFormattedPartsArray = new Intl.DateTimeFormat('en', {
    timeZone: toTimezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(utcDatetime);

  const newTimezoneFormattedParts = Object.fromEntries(
    newTimezoneFormattedPartsArray.map(({ type, value }) => [type, value]),
  );

  // Return new ISO date
  return {
    date: `${newTimezoneFormattedParts.year}-${newTimezoneFormattedParts.month}-${newTimezoneFormattedParts.day}`,
    time: `${newTimezoneFormattedParts.hour}:${newTimezoneFormattedParts.minute}:${newTimezoneFormattedParts.second}`,
  };
}
